const portfolioData = {
  en: {
    name: 'Murilo Farias',
    role: 'Software Engineer - Full Stack',
    location: 'Greater Goiânia, Goiás, Brazil',
    summary:
      'Software developer who learns and applies new concepts without bias toward languages or frameworks — choosing the right technology for each problem. Works across modern and legacy stacks, with experience in backend, frontend, databases, and infrastructure.',
    profile: [
      'Murilo Farias is a full-stack software engineer based in Greater Goiânia, Goiás, Brazil. He writes software end to end — from databases and backend services to the interfaces people actually use — and has spent his career moving between modern and legacy systems without treating either as a dead end.',
      'He began in IT infrastructure in 2005, installing and configuring enterprise networks, before moving into software development. Since 2009 he has built systems for the Tribunal Regional do Trabalho da 18ª Região, the regional federal court that hears labor claims in the state of Goiás, where he developed the "Panorama Orçamentário" budget-visualization software and a module that distributes cases automatically among the court\'s accountants — work that removed the need to hire more staff for triage and distribution.',
      "That range is the point. He learns and applies new concepts without bias toward any language or framework, choosing the technology that fits the problem at hand: Oracle Forms/Reports, PL/SQL, Java EE and PHP on the court's systems; React and Redux while working remotely on a new product for a software company in the San Francisco Bay Area; and Genexus with PostgreSQL on public-health management software earlier on.",
    ],
    skills: [
      'Java',
      'PL/SQL',
      'Oracle',
      'PHP',
      'JavaScript',
      'React',
      'Redux',
      'Ruby',
      'PostgreSQL',
      'Genexus',
      'Cisco Routers',
      '3Com Switches',
      'Fiber Optic',
      'Wireless Technologies',
      'VoIP',
      'SAN',
    ],
    roles: [
      {
        title: 'Software Developer - Full Stack',
        employer: 'Tribunal Regional do Trabalho da 18ª Região',
        period: 'Aug 2009 – Present',
        current: true,
        arrangement: 'Full-time · Hybrid',
        location: 'Greater Goiânia, Goiás, Brazil',
        context:
          'Tribunal Regional do Trabalho da 18ª Região is the Regional Federal Court hearing the labor claims in the state of Goiás, Brazil.',
        accomplishments: [
          'Responsible for the development of the "Panorama Orçamentário" software, which facilitates both the visualization and control of the agency\'s budget.',
          'Created the Automatic Distribution of cases module between case accountants, eliminating the need to hire more employees to do triage, categorization, and distribution of cases to accountants.',
          'Work with cutting-edge and legacy technologies including Oracle Forms/Reports, PL/SQL, Java EE, and PHP.',
        ],
      },
      {
        title: 'Software Engineer - Frontend',
        employer: 'Sisnet LLC',
        period: 'May 2018 – Jul 2022',
        arrangement: 'Part-time · Remote',
        location: 'San Francisco Bay Area',
        context:
          'Sisnet Global offers software products and customized enterprise software development services to help companies and startups succeed in international markets.',
        accomplishments: [
          'Used React and Redux to help implement a new software project.',
        ],
      },
      {
        title: 'Software Developer',
        employer: 'Grupo Assessor Público',
        period: 'Sep 2008 – Aug 2009',
        arrangement: 'Full-time · On-site',
        location: 'Araçatuba, São Paulo, Brazil',
        context:
          'Grupo Assessor Público is a software company that creates solutions for government administration with customers in most parts of Brazil and Angola.',
        accomplishments: [
          'Developed and maintained software built with Genexus and PostgreSQL.',
          'Maintained Public Health Management software.',
          'Created interfaces between the system and JasperServer to enable the creation of reports in plain text for dot matrix printers.',
          'Created an interface for dynamic generation of form pages from parameters received in HTTP requests.',
          'Created a Java library to make password hashes compatible at bit level with the format used in a pre-existing Delphi application.',
        ],
      },
      {
        title: 'Network Technician',
        employer: 'Ensite',
        period: 'Jan 2007 – Jul 2007',
        arrangement: 'Full-time · On-site',
        location: 'Birigui, São Paulo, Brazil',
        context:
          'Ensite is an internet and network solutions provider focused on corporate customers in the northwest region of São Paulo, Brazil.',
        accomplishments: [
          'Provided technical support to customers of internet service plans, prioritizing fast and high-quality customer service.',
        ],
      },
      {
        title: 'Network Technician',
        employer: 'M&A IT Services',
        period: 'May 2005 – Nov 2006',
        arrangement: 'Full-time · On-site',
        location: 'Birigui, São Paulo, Brazil',
        context:
          'M&A IT Services has operated in IT infrastructure services since 2000 with a team experienced in delivering tailored solutions.',
        accomplishments: [
          'Installed and configured industrial and enterprise network assets, including routers, switches, wireless links, fiber-optic infrastructure, and VoIP solutions.',
          'Delivered quality service adapted to each requirement and budget.',
        ],
      },
    ],
  },
  'pt-BR': {
    name: 'Murilo Farias',
    role: 'Engenheiro de Software - Full Stack',
    location: 'Grande Goiânia, Goiás, Brasil',
    summary:
      'Desenvolvedor de software que aprende e aplica novos conceitos sem viés por linguagem ou framework — escolhendo a tecnologia certa para cada problema. Trabalha com stacks modernas e legadas, com experiência em backend, frontend, bancos de dados e infraestrutura.',
    profile: [
      'Murilo Farias é engenheiro de software full stack baseado na Grande Goiânia, Goiás, Brasil. Escreve software de ponta a ponta — de bancos de dados e serviços de backend às interfaces que as pessoas realmente usam — e construiu a carreira transitando entre sistemas modernos e legados, sem tratar nenhum dos dois como beco sem saída.',
      'Começou em infraestrutura de TI em 2005, instalando e configurando redes corporativas, antes de migrar para o desenvolvimento de software. Desde 2009 desenvolve sistemas para o Tribunal Regional do Trabalho da 18ª Região, o órgão que julga as ações trabalhistas no estado de Goiás, onde criou o software "Panorama Orçamentário" e um módulo que distribui processos automaticamente entre os contadores do Tribunal — trabalho que eliminou a necessidade de contratar mais funcionários para a triagem e a distribuição.',
      'Essa amplitude é o ponto. Aprende e aplica novos conceitos sem viés por linguagem ou framework, escolhendo a tecnologia que atende a cada problema: Oracle Forms/Reports, PL/SQL, Java EE e PHP nos sistemas do Tribunal; React e Redux no trabalho remoto em um novo produto para uma empresa de software da região da Baía de São Francisco; e Genexus com PostgreSQL em software de gestão da saúde pública, no início da trajetória.',
    ],
    skills: [
      'Java',
      'PL/SQL',
      'Oracle',
      'PHP',
      'JavaScript',
      'React',
      'Redux',
      'Ruby',
      'PostgreSQL',
      'Genexus',
      'Roteadores Cisco',
      'Switches 3Com',
      'Fibra óptica',
      'Tecnologias sem fio',
      'VoIP',
      'SAN',
    ],
    roles: [
      {
        title: 'Desenvolvedor de Software - Full Stack',
        employer: 'Tribunal Regional do Trabalho da 18ª Região',
        period: 'Ago 2009 – Presente',
        current: true,
        arrangement: 'Tempo integral · Híbrido',
        location: 'Grande Goiânia, Goiás, Brasil',
        context:
          'O Tribunal Regional do Trabalho da 18ª Região é o órgão jurisdicional regional que julga as ações trabalhistas no estado de Goiás.',
        accomplishments: [
          'Responsável pelo desenvolvimento do software "Panorama Orçamentário", que facilita a visualização e o controle do orçamento do órgão.',
          'Criou o módulo de Distribuição Automática de processos entre os contadores, eliminando a necessidade de contratar mais funcionários para realizar a triagem, categorização e distribuição dos processos aos contadores.',
          'Trabalha com tecnologias de ponta e legadas, incluindo Oracle Forms/Reports, PL/SQL, Java EE e PHP.',
        ],
      },
      {
        title: 'Engenheiro de Software - Frontend',
        employer: 'Sisnet LLC',
        period: 'Mai 2018 – Jul 2022',
        arrangement: 'Tempo parcial · Remoto',
        location: 'Região da Baía de São Francisco, EUA',
        context:
          'A Sisnet Global oferece produtos de software e serviços personalizados de desenvolvimento para ajudar empresas e startups a terem sucesso no mercado internacional.',
        accomplishments: [
          'Utilizou React e Redux para auxiliar na implementação de um novo projeto de software.',
        ],
      },
      {
        title: 'Desenvolvedor de Software',
        employer: 'Grupo Assessor Público',
        period: 'Set 2008 – Ago 2009',
        arrangement: 'Tempo integral · Presencial',
        location: 'Araçatuba, São Paulo, Brasil',
        context:
          'O Grupo Assessor Público é uma empresa de software que desenvolve soluções para administração pública, com clientes em diversas regiões do Brasil e em Angola.',
        accomplishments: [
          'Desenvolveu e deu manutenção em sistemas construídos com Genexus e PostgreSQL.',
          'Realizou manutenção no software de Gestão da Saúde Pública.',
          'Criou interfaces entre o sistema e o JasperServer para permitir a geração de relatórios em texto puro para impressoras matriciais.',
          'Criou uma interface para geração dinâmica de páginas de formulários a partir de parâmetros recebidos via HTTP.',
          'Criou uma biblioteca Java para tornar hashes de senha compatíveis, em nível de bits, com o formato utilizado em um sistema Delphi já existente.',
        ],
      },
      {
        title: 'Técnico de Redes',
        employer: 'Ensite',
        period: 'Jan 2007 – Jul 2007',
        arrangement: 'Tempo integral · Presencial',
        location: 'Birigui, São Paulo, Brasil',
        context:
          'A Ensite é provedora de soluções de internet e rede voltada a clientes corporativos na região noroeste do estado de São Paulo.',
        accomplishments: [
          'Prestou suporte técnico aos clientes dos planos de serviço de internet, priorizando agilidade e qualidade no atendimento.',
        ],
      },
      {
        title: 'Técnico de Redes',
        employer: 'M&A IT Services',
        period: 'Mai 2005 – Nov 2006',
        arrangement: 'Tempo integral · Presencial',
        location: 'Birigui, São Paulo, Brasil',
        context:
          'A M&A IT Services atua no mercado de serviços de infraestrutura de TI desde 2000, com equipe experiente em soluções sob medida para cada necessidade.',
        accomplishments: [
          'Instalou e configurou ativos de rede industrial e empresarial, incluindo roteadores, switches, enlaces sem fio, infraestrutura de fibra óptica e soluções VoIP.',
          'Prestou serviços com qualidade, adaptados a cada requisito e orçamento.',
        ],
      },
    ],
  },
};

module.exports = portfolioData;
